module.exports = __webpack_public_path__ + "images/Monarch_Institute.svg";